function main({children}) {
  return <main className="main">{children}</main>;
}

export default main;
